export default __webpack_public_path__ + "static/media/main.1c22dabd.jpg";